/**
 * Static home-dashboard chart data (fallback when API is unavailable).
 * LineChart uses `label` + `data[{ x, y }]`.
 * ClusterColumnChart uses `label` + `data[{ "<series name>": number, ... }]`.
 */

const DASHBOARD_DEFAULT_MONTH_COUNT = 3;

const MONTHS_2025 = [
  'Jan 2025',
  'Feb 2025',
  'Mar 2025',
  'Apr 2025',
  'May 2025',
  'Jun 2025',
  'Jul 2025',
  'Aug 2025',
  'Sep 2025',
  'Oct 2025',
  'Nov 2025',
  'Dec 2025',
];

function zipSeries(xs, ys) {
  return xs.map((x, i) => ({ x, y: ys[i] ?? 0 }));
}

const submittedRequestsY = [4, 6, 5, 8, 10, 9, 12, 14, 11, 15, 18, 16];
const completedRequestsY = [2, 3, 4, 4, 5, 6, 7, 6, 8, 9, 10, 11];
const inReviewQueueY = [8, 9, 7, 10, 12, 11, 14, 13, 15, 14, 12, 10];

const DEFAULT_MONTHS = MONTHS_2025.slice(-DASHBOARD_DEFAULT_MONTH_COUNT);

export const HOME_LINE_CHART_DATA = [
  {
    label: 'All requests',
    data: zipSeries(
      DEFAULT_MONTHS,
      submittedRequestsY.slice(-DASHBOARD_DEFAULT_MONTH_COUNT)
    ),
  },
  {
    label: 'Completed requests',
    data: zipSeries(
      DEFAULT_MONTHS,
      completedRequestsY.slice(-DASHBOARD_DEFAULT_MONTH_COUNT)
    ),
  },
  {
    label: 'In review / send-back',
    data: zipSeries(
      DEFAULT_MONTHS,
      inReviewQueueY.slice(-DASHBOARD_DEFAULT_MONTH_COUNT)
    ),
  },
];

export const HOME_CLUSTER_COLUMN_CHART_DATA = MONTHS_2025.slice(
  -DASHBOARD_DEFAULT_MONTH_COUNT
).map((label, i) => {
  const idx = MONTHS_2025.length - DASHBOARD_DEFAULT_MONTH_COUNT + i;
  return {
    label,
    data: [
      {
        'New submissions': submittedRequestsY[idx],
        'Completed requests': completedRequestsY[idx],
      },
    ],
  };
});

/** Zeroed fallbacks for customer dashboards (never show demo/global volumes). */
export const EMPTY_LINE_CHART_DATA = HOME_LINE_CHART_DATA.map((series) => ({
  label: series.label,
  data: series.data.map((point) => ({ x: point.x, y: 0 })),
}));

export const EMPTY_CLUSTER_COLUMN_CHART_DATA =
  HOME_CLUSTER_COLUMN_CHART_DATA.map((row) => ({
    label: row.label,
    data: [{ 'New submissions': 0, 'Completed requests': 0 }],
  }));

/** Demo payment cost totals (major currency units, e.g. EGP). */
const succeededPaymentCostsY = [
  45, 75, 60, 105, 135, 120, 150, 180, 135, 165, 210, 195,
];
const failedPaymentCostsY = [15, 15, 30, 15, 30, 15, 30, 45, 30, 15, 30, 30];
const pendingPaymentCostsY = [30, 45, 30, 60, 45, 75, 60, 45, 75, 60, 45, 60];

export const HOME_PAYMENT_LINE_CHART_CURRENCY = 'EGP';

export const HOME_PAYMENT_LINE_CHART_DATA = [
  {
    label: 'Failed',
    data: zipSeries(
      DEFAULT_MONTHS,
      failedPaymentCostsY.slice(-DASHBOARD_DEFAULT_MONTH_COUNT)
    ),
  },
  {
    label: 'Pending',
    data: zipSeries(
      DEFAULT_MONTHS,
      pendingPaymentCostsY.slice(-DASHBOARD_DEFAULT_MONTH_COUNT)
    ),
  },
  {
    label: 'Succeeded',
    data: zipSeries(
      DEFAULT_MONTHS,
      succeededPaymentCostsY.slice(-DASHBOARD_DEFAULT_MONTH_COUNT)
    ),
  },
];

const succeededPaymentsMonthly = [3, 5, 4, 7, 9, 8, 10, 12, 9, 11, 14, 13];
const failedPaymentsMonthly = [1, 1, 2, 1, 2, 1, 2, 3, 2, 1, 2, 2];

export const HOME_PAYMENT_CLUSTER_COLUMN_CHART_DATA = MONTHS_2025.slice(
  -DASHBOARD_DEFAULT_MONTH_COUNT
).map((label, i) => {
  const idx = MONTHS_2025.length - DASHBOARD_DEFAULT_MONTH_COUNT + i;
  return {
    label,
    data: [
      {
        'Succeeded payments': succeededPaymentsMonthly[idx],
        'Failed payments': failedPaymentsMonthly[idx],
      },
    ],
  };
});

export const EMPTY_PAYMENT_LINE_CHART_DATA = HOME_PAYMENT_LINE_CHART_DATA.map(
  (series) => ({
    label: series.label,
    data: series.data.map((point) => ({ x: point.x, y: 0 })),
  })
);

export const EMPTY_PAYMENT_CLUSTER_COLUMN_CHART_DATA =
  HOME_PAYMENT_CLUSTER_COLUMN_CHART_DATA.map((row) => ({
    label: row.label,
    data: [{ 'Succeeded payments': 0, 'Failed payments': 0 }],
  }));
